module.exports = __webpack_public_path__ + "img/full0-min.63c7d1c2.png";